import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { AboutContent } from "@/components/hilltop/AboutContent";

export const Route = createFileRoute("/_public/about")({
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutContent />
      <Footer />
    </div>
  );
}
